import { LocalDateTime } from 'js-joda';
import { core, toJSON } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

export interface State {
  currentMfa?: {
    factor: core.IMfaFactor;
    otpSessionUuid?: string;
  };
  mostRecentCodeResend?: string;
}

const initialState: State = {};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.DASHBOARD_INITIATE_AUTH_DONE: {
      const dashboardAuthResponse = toJSON<core.DashboardAuthResponse>(payload);
      switch (dashboardAuthResponse.response) {
        case 'authResponse': {
          return { ...state, currentMfa: undefined, mostRecentCodeResend: undefined };
        }
        case 'mfaRequiredAuthResponse': {
          const { otpSessionUuid, factor } = dashboardAuthResponse.mfaRequiredAuthResponse ?? {};
          if (!factor?.email) {
            return { ...state };
          }
          return {
            ...state,
            currentMfa: {
              otpSessionUuid: otpSessionUuid ?? undefined,
              factor,
            },
            mostRecentCodeResend: undefined,
          };
        }
      }
      const { otpSessionUuid, factor } = (dashboardAuthResponse.mfaRequiredAuthResponse ??
        {}) as core.IMfaRequiredAuthResponse;
      if (!factor?.email) {
        return { ...state };
      }
      return {
        ...state,
        currentMfa: {
          otpSessionUuid: otpSessionUuid ?? undefined,
          factor,
        },
        mostRecentCodeResend: undefined,
      };
    }
    case AppConstants.DASHBOARD_MFA_VERIFY_DONE: {
      return { ...state, currentMfa: undefined, mostRecentCodeResend: undefined };
    }
    case AppConstants.DASHBOARD_MFA_RESEND_CODE_DONE: {
      return { ...state, mostRecentCodeResend: LocalDateTime.now().toString() };
    }
    default: {
      return state;
    }
  }
}
